import * as React from "react";
import antd, { Row, Col, Button, Icon } from 'antd';
import landing_page_graphic from '../../../assets/images/Landing_Page_Graphic.png'
import kwl_banking_info from '../../../assets/images/KWL_Banking_Information.jpg'
import AuthContext from "Context/AuthContext";
import { RouteComponentProps, withRouter } from "react-router";

export interface Props extends RouteComponentProps {
    children?: React.ReactNode
}
export interface State {
}


class BaseHomeDescription extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;
    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    register = (e: React.FormEvent) => {
        e.preventDefault();
        this.props.history.push('/sign-up');
    }

    nagivateToClickNCollect = (e: React.FormEvent) => {
        e.preventDefault();
        this.props.history.push('/click-n-go');
    }

    getCharges = (e: React.FormEvent) => {
        e.preventDefault();
        this.props.history.push('/charges');
    }

    columnStyle = {
        margin: '30px 20px 10px 30px', // margin: top right bottom left;
    };

    render() {
        return (
            <Col xs={{ span: 24 }} lg={{ span: this.context.data ? 15 : 17, offset: 0 }} style={this.columnStyle}>
                <Row justify="space-around"
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                >
                    <Col style={{ marginBottom: 10 }}

                        xs={22} sm={22} md={22} lg={10} xl={10}
                    >
                        <img style={{ width: '95%', height: '95%', marginRight: '20px' }} src={landing_page_graphic} alt="loading containers" />
                    </Col>

                    <Col xs={22} sm={22} md={22} lg={13} xl={13} offset={0}>
                        <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px", marginTop: "5px" }}>
                            <article>

                                <section>
                                    <div style={{ fontSize: ".9em" }}>
                                        <section style={{ textAlignLast: "left" }}>
                                            <p>
                                                Welcome to Kingston Wharves Limited’s eServices portal, revolutionising shipping services by
                                                putting our convenient cargo clearance and ePayment options at your fingertips. <br />
                                            </p>
                                        </section>

                                        {this.context.data != undefined ?
                                            <section>
                                                <h4 style={{ marginTop: 30 }}>Use your bill of lading number to View &amp; Pay Charges or Register for Click N Collect </h4>
                                                <p><Button size="large" type="primary" onClick={this.getCharges}>Get &amp; Pay Charges</Button></p>
                                                <p> <Button size="large" type="primary" style={{ width: "225px" }} onClick={this.nagivateToClickNCollect}>Click N Collect</Button></p>
                                            </section>
                                            :
                                            <>
                                                <section style={{ textAlignLast: "left" }}>
                                                    <p>

                                                        Use any of our electronic payment options to pay for Any Shipment, from Anywhere in the world, at
                                                        Any Time of the day or night.<br /><br />

                                                        With one login, you can use multiple KWL eServices options including out pick up service, Click N Collect, and the electronic payment options — your eServices login
                                                        credentials can be used to access the Mobile App and webPay. <br /><br />
                                                    </p>
                                                </section>

                                                <section style={{ textAlignLast: "left" }}>
                                                    <p>
                                                        <ol>
                                                            <p>
                                                                <Button style={{ display: "block", marginLeft: "auto", marginRight: "auto" }} type="primary" size="default" onClick={this.register}>Sign Up</Button>
                                                            </p>
                                                            <li>
                                                                <p><strong>Click N Collect –</strong>  </p>
                                                                Click N Collect is cargo clearance made easier. Kingston Wharves or your agent will
                                                                handle the entire clearance process on your behalf. Simply pay online and schedule your
                                                                pick up at your convenience.

                                                            </li>
                                                            <br />
                                                            <li> <strong>KW Web Pay -</strong> Simply Register and pay for your shipment.</li>
                                                            <br />
                                                            <li><strong>Mobile App -</strong> Pay for any shipment, any time, once you have a bill of lading number.
                                                                <br />
                                                                <section >

                                                                    <a href='https://play.google.com/store/apps/details?id=com.kwl.mobile.kopp&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                                                                        <img alt='Get it on Google Play' style={{ width: "150px", height: "60px", display: "block", marginLeft: "auto", marginRight: "auto" }} src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' />
                                                                    </a>
                                                                </section>
                                                            </li>
                                                            <li>
                                                                <p>
                                                                    <strong>Bank Transfer</strong> to the KWL account. We recommend this option for orders/bills of ladings required after
                                                                    24-48 hours. <strong>Download the KWL Banking Information <a href={kwl_banking_info} download="KWL Banking Information">here</a> or contact <a href="mailto:customer.services@kwljm.com">customer.services@kwljm.com</a></strong>.
                                                                    After payment, send email confirmation to <a href="mailto:kwfinance@kwljm.com">kwfinance@kwljm.com</a> and <a href="mailto:customer.services@kwljm.com">customer.services@kwljm.com</a> to ensure the payment is
                                                                    applied to your order.
                                                                </p>
                                                            </li>
                                                        </ol>
                                                    </p>
                                                </section>
                                            </>

                                        }
                                    </div>
                                </section>
                            </article>

                        </Row>
                    </Col>
                </Row>


            </Col>
        )
    }
}

const HomeDescription = withRouter(BaseHomeDescription);

export default HomeDescription;

